import React from 'react';
import {IIconProps} from "../../../ui/svg/interfaces";

const SbsEyeIcon = (props: IIconProps) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.width} viewBox="0 0 23 14" fill="none">
        <g opacity={props.color ? 1 : 0.3}>
            <title>{props.title}</title>
            <path fillRule="evenodd" clipRule="evenodd" d="M11.0529 13.7719C11.0529 13.7719 11.0822 13.7719 11.0529 13.7719C17.1447 13.7719 21.0125 9.05365 22.0523 7.61843C22.3117 7.26704 22.3117 6.79774 22.0523 6.41657C21.0126 4.8931 17.1742 0 11.1398 0H11.053C4.93316 0.0583756 1.18027 4.92305 0.169878 6.44646C-0.0612939 6.79785 -0.0612939 7.29575 0.199197 7.64832C1.52648 9.46481 5.27946 13.7719 11.0531 13.7719H11.0529ZM11.0643 2.11875H11.1526C15.6688 2.11875 18.8083 5.31694 20.1281 6.98662C18.8083 8.57102 15.6403 11.6531 11.0942 11.6531H11.0644C6.6649 11.6531 3.58525 8.743 2.11875 6.98662C3.3206 5.46072 6.45871 2.14784 11.0644 2.11875H11.0643Z" fill={props.color ? props.color : "#C8C8C8"}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14.2469 6.8847C14.2469 8.63971 12.8241 10.0633 11.0683 10.0633C9.31328 10.0633 7.89062 8.63962 7.89062 6.8847C7.89062 5.12978 9.3134 3.70703 11.0683 3.70703C12.8242 3.70703 14.2469 5.1298 14.2469 6.8847Z" fill={props.color ? props.color : "#C8C8C8"}/>
        </g>
    </svg>
  )
};

export default SbsEyeIcon;